import { TFunction } from 'i18next';
import { AnchorItemKey } from '../../types';
import { AnchorItem } from './types';

export const DEFAULT_ANCHOR = `#${AnchorItemKey.GENERAL_INFORMATION}`;

export const getAnchorItems = (
  t: TFunction,
  isAiAgentSettingsEnabled: boolean = false
): AnchorItem[] => {
  const items: AnchorItem[] = [
    {
      key: '1',
      title: t('anchor_item_title.general_information'),
      href: `#${AnchorItemKey.GENERAL_INFORMATION}`,
    },
    {
      key: '2',
      title: t('anchor_item_title.pic_and_contact_information'),
      href: `#${AnchorItemKey.PIC_AND_CONTACT_INFORMATION}`,
    },
    {
      key: '3',
      title: t('anchor_item_title.receiving_method'),
      href: `#${AnchorItemKey.RECEIVING_METHOD}`,
    },
  ];

  if (isAiAgentSettingsEnabled) {
    items.push({
      key: '4',
      title: t('ai_agents_setting'),
      href: `#${AnchorItemKey.AI_AGENT}`,
    });
  }

  items.push({
    key: '5',
    title: t('anchor_item_title.default_payment_method'),
    href: `#${AnchorItemKey.DEFAULT_PAYMENT_METHOD}`,
    children: [
      {
        key: '6',
        title: t('anchor_item_title.payment_rule'),
        href: `#${AnchorItemKey.PAYMENT_RULE}`,
      },
      {
        key: '7',
        title: t('anchor_item_title.transaction_default_value'),
        href: `#${AnchorItemKey.TRANSACTION_DEFAULT_VALUE}`,
      },
    ],
  });

  return items;
};
